import { lazy } from "react";

const CiroRoutes = [
  {
    path: "/risk/risky-sales",
    component: lazy(() => import("../../views/risk/RiskTable")),
  },
  {
    path: "/risk/banned-words",
    component: lazy(() => import("../../views/risk/BannedWords")),
  },
  {
    path: "/risk/banned-accounts",
    component: lazy(() => import("../../views/risk/BannedAccountsTable")),
  },
  {
    path: "/risk/suspicious-accounts",
    component: lazy(() => import("../../views/risk/SuspiciousAccountTable")),
  },
];

export default CiroRoutes;
